import { useEffect, useRef, useState } from 'react';

const COOLDOWN_SECONDS = 60;

export function useResendCooldown() {
  const [secondsLeft, setSecondsLeft] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | undefined>(undefined);

  useEffect(() => () => clearInterval(intervalRef.current), []);

  function start() {
    setSecondsLeft(COOLDOWN_SECONDS);
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          clearInterval(intervalRef.current);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
  }

  return { secondsLeft, start, canResend: secondsLeft === 0 };
}
